<div class="cass-dialog" [class.info]="data.dialogType==='info'" [class.warning]="data.dialogType==='warning'">
	<h1 *ngIf="data.titleKey" mat-dialog-title>{{ data.titleKey | translate }}</h1>
	<div mat-dialog-content>
		<div *ngIf="data.prompt" [formGroup]="formGroup" class="dense-component-container">
			{{ data.prompt | translate }}
			<mat-form-field>
				<input matInput formControlName="editField" required>
			</mat-form-field>
		</div>
		<div *ngIf="data.messageKey" class="message">{{ data.messageKey | translate:data.messageParams }}</div>
		<div *ngIf="data.message" class="message">{{ data.message }}</div>
		<div *ngIf="data.footerKey" class="footer">{{ data.footerKey | translate }}</div>
	</div>
	<div mat-dialog-actions align="end">
		<button *ngFor="let action of data.actions" mat-button (click)="onAction(action.id)" class="{{ action.cssClass }}">{{ action.labelKey | translate }}</button>
	</div>
</div>
